import React from 'react';
import './Home.css';

import AboutMe from '../AboutMe/AboutMe';

const Home = function() {
  return (
      <div className="container home">
        <div className="main-content">
          <AboutMe/>
        </div>
      </div>
  );
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home/Home.js